export   const series = [{
	name: 'Stock Price',
	type: 'area',
	data: [500000, 400000, 1000000, 900000, 1100000, 1500000, 900000, 1400000, 1100000,1000000, 450000, 400000]
      }, {
	name: 'Volume of grievances',
	type: 'line',
	data: [400000, 300000, 500000, 600000, 800000, 750000, 650000, 690000, 750000, 500000, 110000, 60000]
      }
      ]